import { Link } from "react-router-dom";
import { ArrowRight, MapPin, ShieldCheck, Clock } from "lucide-react";
import { LOGO_URL } from "@/lib/brand";

export default function Splash() {
  return (
    <div className="mobile-shell relative overflow-hidden">
      {/* Deep blue hero with logo */}
      <div className="relative h-[56vh] w-full overflow-hidden" style={{ background: "radial-gradient(1200px 600px at 50% -10%, rgba(60,255,126,0.25), transparent 55%), linear-gradient(180deg, #0B1E5B 0%, #07122F 100%)" }}>
        {/* Radial grid */}
        <div className="absolute inset-0 opacity-[0.08]" style={{ backgroundImage: "linear-gradient(rgba(255,255,255,0.6) 1px, transparent 1px), linear-gradient(90deg, rgba(255,255,255,0.6) 1px, transparent 1px)", backgroundSize: "24px 24px" }} />
        <div className="absolute inset-0 flex flex-col items-center justify-center px-6 text-center">
          <div className="w-44 h-44 rounded-full overflow-hidden bg-white/5 ring-2 ring-[#3CFF7E]/40 drop-shadow-[0_0_30px_rgba(60,255,126,0.35)]">
            <img src={LOGO_URL} alt="AutoFix Rescue" className="w-full h-full object-cover scale-110" />
          </div>
          <div className="mt-6 text-[10px] font-bold uppercase tracking-[0.3em] text-[#3CFF7E] font-display">
            Est. 2026 · 24/7 Rescue
          </div>
          <h1 className="font-display text-4xl sm:text-5xl font-black leading-[0.95] tracking-tight text-white mt-3">
            Stranded?<br/>
            <span className="text-[#3CFF7E]">Help is 5 min away.</span>
          </h1>
        </div>
      </div>

      {/* Content */}
      <div className="px-6 py-8 anim-slide-up">
        <div className="grid grid-cols-3 gap-3 mb-8">
          <Feature icon={<MapPin size={18} />} label="GPS MATCH" />
          <Feature icon={<Clock size={18} />} label="5 MIN ETA" />
          <Feature icon={<ShieldCheck size={18} />} label="VETTED" />
        </div>

        <p className="text-[#9CA3AF] text-base leading-relaxed mb-8">
          Connect with the nearest verified mechanic for breakdowns, towing, diagnostics and more.
          Track the job live — pay after it's done.
        </p>

        <div className="space-y-3">
          <Link
            to="/register"
            data-testid="splash-get-started-btn"
            className="w-full h-14 bg-[#3CFF7E] text-[#0A0A0A] font-display font-bold uppercase tracking-wider rounded-md flex items-center justify-center gap-2 active:scale-[0.98] transition-transform shadow-[0_0_40px_rgba(60,255,126,0.35)]"
          >
            I Need Help <ArrowRight size={18} />
          </Link>
          <Link
            to="/mechanic-intro"
            data-testid="splash-mechanic-btn"
            className="w-full h-14 border border-[#3CFF7E]/40 bg-[#3CFF7E]/5 text-[#3CFF7E] font-display font-bold uppercase tracking-wider rounded-md flex items-center justify-center gap-2 active:scale-[0.98] transition-transform"
          >
            I'm a Mechanic
          </Link>
          <Link
            to="/login"
            data-testid="splash-login-btn"
            className="w-full h-14 border border-white/20 text-white font-display font-bold uppercase tracking-wider rounded-md flex items-center justify-center active:scale-[0.98] transition-transform"
          >
            I Already Have an Account
          </Link>
        </div>
      </div>
    </div>
  );
}

function Feature({ icon, label }) {
  return (
    <div className="border border-white/10 rounded-md p-3 flex flex-col items-start gap-2 bg-[#111827]">
      <div className="text-[#3CFF7E]">{icon}</div>
      <div className="text-[10px] font-bold uppercase tracking-[0.15em] text-white font-display">
        {label}
      </div>
    </div>
  );
}
